export type TermsResponse = {
  isUser: boolean;
  terms: Terms[];
};

export type TermsContentsResponse = {
  terms: TermsContents[];
};

export type TermsSubmitResponse = {
  code: string;
  data: unknown;
  message: string;
};

export type TermsContents = {
  title: string;
  termsVersion: string;
  contentUrl: string;
  sortableDate: string;
};

export type Terms = {
  category: TermsCategory;
  isAgreed: boolean;
  isRequired: boolean;
  isUpdated: boolean;
  title: string;
  type: number;
  version: string;
};

export enum TermsCategory {
  INFO_COLLECTION = 5,
  RECEIVE_MARKETING_INFO = 6,
}

export enum ServiceCode {
  ROAMING = 'ROAMING',
  IXIO = 'IXIO',
  IN_CALL_AI = 'IN_CALL_AI',
  LAB = 'LAB',
  HOME_WIFI_CALL = 'HOME_WIFI_CALL',
}

export type V2Terms = {
  isUpdated: boolean;
  isRequired: boolean;
  isAgreed: boolean;
  title: string;
  serviceCode: ServiceCode;
  contentUrl: string;
  category: number;
  parentCategory: number;
  version: string;
  activeAt: string;
};

export type V2TermsResponse = {
  isUser: boolean;
  terms: V2Terms[];
};
